import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import LeadForm from "@/components/LeadForm";

// Gated content: show lead form first, then reveal info / trigger action
export default function GatedLeadModal({ open, onOpenChange, projectName, title, description, leadType = "brochure", onUnlock }) {
  const [unlocked, setUnlocked] = useState(false);

  const handleSuccess = () => {
    setUnlocked(true);
    if (onUnlock) onUnlock();
    setTimeout(() => onOpenChange(false), 400);
    setTimeout(() => setUnlocked(false), 800);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="gated-lead-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-navy">{title || "Get Instant Access"}</DialogTitle>
          <DialogDescription>{description || "Please share your details to view this information."}</DialogDescription>
        </DialogHeader>
        <LeadForm variant="gated" leadType={leadType} projectName={projectName} redirectThankYou={false} onSuccess={handleSuccess} />
      </DialogContent>
    </Dialog>
  );
}
